import { render, staticRenderFns } from "./RpmOverviewModal.vue?vue&type=template&id=2d681197&scoped=true"
import script from "./RpmOverviewModal.vue?vue&type=script&lang=js"
export * from "./RpmOverviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d681197",
  null
  
)

export default component.exports